import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { initialValues, validationSchema } from './formData';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import { PqrInitialCausality } from '../../../../../../shared/types/modules/pqr';
import { PqrInitialCausalityProps } from './props';
import { asyncGetProducts } from '../../../../../../services/product.service';
import { formatParams } from '../../../../../../shared/utils/params';
import { asyncGetParams } from '../../../../../../services/param.service';

export const usePqrInitialCausality = ({
    data,
    onChangeData,
    onChangeFormik,
    typePqr,
}: PqrInitialCausalityProps) => {
    const [products, setproducts] = useState<ISelect[]>([]);
    const [motives, setMotives] = useState<ISelect[]>([]);
    const [submotives1, setSubmotives1] = useState<ISelect[]>([]);
    const [submotives2, setSubmotives2] = useState<ISelect[]>([]);
    const [submotives3, setSubmotives3] = useState<ISelect[]>([]);
    const [submotives4, setSubmotives4] = useState<ISelect[]>([]);

    const onSubmit = (data: PqrInitialCausality) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema(
            submotives1.length > 0,
            submotives2.length > 0,
            submotives3.length > 0,
            submotives4.length > 0
        ),
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        if (data) {
            formik?.setFieldValue('product', data?.product || '');
            formik?.setFieldValue('motive', data?.motive || '');

            formik?.setFieldValue('submotive1', data?.submotive1 || '');

            if (data?.submotive1 && data?.submotive2) {
                formik?.setFieldValue('submotive2', data?.submotive2);
            } else {
                formik?.setFieldValue('submotive2', '');
            }

            if (data?.submotive1 && data?.submotive2 && data?.submotive3) {
                formik?.setFieldValue('submotive3', data?.submotive3);
            } else {
                formik?.setFieldValue('submotive3', '');
            }

            if (
                data?.submotive1 &&
                data?.submotive2 &&
                data?.submotive3 &&
                data?.submotive4
            ) {
                formik?.setFieldValue('submotive4', data?.submotive4);
            } else {
                formik?.setFieldValue('submotive4', '');
            }
        }
    }, [data]);

    useEffect(() => {
        asyncGetProducts({ applyPqr: true }).then((items) =>
            setproducts(formatParams(items))
        );
        if (typePqr) {
            asyncGetParams(ParamEnum.PQR_MOTIVE, undefined, typePqr).then(
                setMotives
            );
        }
    }, [typePqr]);

    useEffect(() => {
        const value = formik.values.motive as string;
        if (value?.trim()) {
            asyncGetParams(undefined, undefined, value).then((items) =>
                setSubmotives1(items)
            );
        } else {
            setSubmotives1([]);
            formik.setFieldValue('submotive1', '');
            formik.setFieldValue('submotive2', '');
            formik.setFieldValue('submotive3', '');
            formik.setFieldValue('submotive4', '');
        }
    }, [formik.values.motive]);

    useEffect(() => {
        const value = formik.values.submotive1 as string;
        if (value?.trim()) {
            asyncGetParams(undefined, undefined, value).then((items) =>
                setSubmotives2(items)
            );
        } else {
            setSubmotives2([]);
            formik.setFieldValue('submotive2', '');
            formik.setFieldValue('submotive3', '');
            formik.setFieldValue('submotive4', '');
        }
    }, [formik.values.submotive1]);

    useEffect(() => {
        const value = formik.values.submotive2 as string;
        if (value?.trim()) {
            asyncGetParams(undefined, undefined, value).then((items) =>
                setSubmotives3(items)
            );
        } else {
            setSubmotives3([]);
            formik.setFieldValue('submotive3', '');
            formik.setFieldValue('submotive4', '');
        }
    }, [formik.values.submotive2]);

    useEffect(() => {
        const value = formik.values.submotive3 as string;
        if (value?.trim()) {
            asyncGetParams(undefined, undefined, value).then((items) =>
                setSubmotives4(items)
            );
        } else {
            setSubmotives4([]);
            formik.setFieldValue('submotive4', '');
        }
    }, [formik.values.submotive3]);

    return {
        formik,
        products,
        motives,
        submotives1,
        submotives2,
        submotives3,
        submotives4,
    };
};
